import { NgModule } from '@angular/core';
import { PreloadAllModules, RouteReuseStrategy, Router, RouterModule, Routes } from '@angular/router';

import { AuthModule, AuthGuard } from '@dexio/common';
import { HomePageComponent } from './pages/home/home-page.component';
import { MainLayoutComponent } from './modules/lorax/layout/app-layout/main-layout/main-layout.component';
import { SearchPageComponent } from './pages/search/search-page.component';
import { AppRouteReuseStrategy } from './app-route-reuse-strategy';

const routes: Routes = [  
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: HomePageComponent, canActivate: [ AuthGuard ]},
      { path: 'search', component: SearchPageComponent, canActivate: [ AuthGuard ] },
    ]
  },
  {
    path: 'projects',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: []
  },
  {
    path: 'reports',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'dexioauth',
    loadChildren: () => AuthModule
  },
  {
    path: 'admin',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload'
    })],
  exports: [RouterModule],
  providers: [
    {
      provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy
    }
  ]
})
export class AppRoutingModule { }
